import { LanguageType } from '@nx-smartmonkey/shared/domain';
import { useTranslationsContext } from '../../context/translations/context';

type UseRetrieveActiveLanguageResponse = {
  activeLanguage?: LanguageType;
};

// Hooks act as 'Adapter' layer.
export const useRetrieveActiveLanguage = (): UseRetrieveActiveLanguageResponse => {
  const { translationsState } = useTranslationsContext();
  return {
    activeLanguage: translationsState.activeLanguage
      ? (translationsState.activeLanguage.locale as LanguageType)
      : undefined,
  };
};
